export function getFirebaseStorageUrl(path) {
  if (!path) return '/assets/logo.png';

  const bucket = process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET;
  if (!bucket) return '/assets/logo.png';

  return `https://firebasestorage.googleapis.com/v0/b/${bucket}/o/${encodeURIComponent(path)}?alt=media`;
}
